<template>
  <GDialog
    v-model="dialogState"
    :max-width="maxWidth"
    content-class="rounded-lg shadow-lg bg-white"
    :persistent="persistent"
    @update:modelValue="onClose"
  >
    <div
      class="flex flex-col gap-y-4 p-4"
      :class="`${awardStore.activeAward?.table} ${height}`"
    >
      <h2 v-if="title">{{ title }}</h2>

      <slot name="content"><p v-html="message" /></slot>

      <slot name="buttons">
        <div class="flex justify-center gap-x-2">
          <Button v-if="showCancelButton" color="transparent" @click="close">
            Cancel
          </Button>
          <Button @click="close"> OK </Button>
        </div>
      </slot>
    </div>
  </GDialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useAwardStore } from "@/stores";
import { mapStores } from "pinia";

export default defineComponent({
  name: "GenericDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: 444,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    message: {
      type: String,
      required: false,
      default: "",
    },
    showCancelButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: "",
    },
    onClose: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  computed: {
    ...mapStores(useAwardStore),
    dialogState: {
      get() {
        return this.modelValue;
      },
      set(value: boolean) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    close() {
      this.dialogState = false;
    },
  },
});
</script>
